import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers";
import { devToolsEnhancer } from "redux-devtools-extension";
import thunkMiddleware from 'redux-thunk';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer, /* preloadedState */
    composeEnhancers(
        applyMiddleware(
            thunkMiddleware,
        )
    )
);

// End-to-end tests only (REACT_APP_E2E=1 builds; webpack drops this from every real build).
if (process.env.REACT_APP_E2E === "1" && typeof window !== "undefined") (window as any).__rafikiStore = store;

export default store;
